<template>
    <div class="container section">
        <div class="row heading">
            <div class="col">
                <h2>{{label}} Cashflow </h2>
            </div>
            <div class="col text-right">
                <button class="btn btn-primary" @click="saveToDashboard()"><i class="fa fa-save"></i> &nbsp;Save To Dashboard</button>
            </div>

        </div>

        <div class="row">
            <div class="loader-holder" v-show="loading">
                <loading color="#5e9cd3"></loading>
            </div>
            <div class="col chart-col">
                <!-- Charts -->
                <div class="row ">
                    <div class="col dashboard-section">
                        <label>Cash Flow Trends</label>
                        <canvas id="chart">
                        </canvas>
                    </div>
                </div>

                <div class="row">
                    <div class="col dashboard-section">
                        <label>Total Lifetime Cashflow</label>
                        <div class="display text-center">
                            <span class="displayNum">${{value | formatMoney}}</span>

                        </div>
                    </div>
                </div>

            </div>
            <div class="col ledger-col">
                <!--  ledger -->

                <div class="row lined head">

                    <div class="col-lg-4 col-form-label">
                        <h5>Transactions</h5>
                    </div>
                    <div class="col-lg-8 text-right">
                <span class="col-form-label pagination-description">
                  {{this.paginate.current_page}} of {{this.paginate.num_pages}} pages
                </span>
                        <paginate
                                :page-count="paginate.num_pages"
                                :initial-page="paginate.current_page - 1"
                                :page-range= 3
                                :margin-pages= 1
                                :click-handler="paginateClick"
                                container-class="pagination"
                                page-class="page-item"
                                page-link-class="page-link"
                                prev-class="page-item"
                                prev-link-class="page-link"
                                next-class="page-item"
                                next-link-class="page-link"
                        ></paginate>

                    </div>
                </div>


                <div class="row lined" v-for="line in cashflowTransactions" :class="[(line.amount < 0) ? 'text-danger': '']">
                    <div class="col">
                        {{line.date_posted | formatDate}}
                    </div>
                    <div class="col">
                        {{line.description}}
                    </div>
                    <div class="col text-right">
                        ${{line.amount}}
                    </div>

                </div>

                <!--
                  <div class="row lined total">
                    <div class="col">
                      <strong>Total</strong>
                    </div>
                    <div class="col text-right">
                      <strong>${{sumAmt | formatMoney}}</strong>
                    </div>

                  </div>
        -->
            </div>
        </div>
    </div>

</template>
<script type="text/babel">
    var Paginate = require('vuejs-paginate');
    import Loading from 'vue-spinner/src/PulseLoader.vue';

    export default {
        data: function(){
            return {
                chart: null,
                chartDiv:{},
                value: 0,
                count: 0,
                cashflowTransactions: [],
                cashflow:[],
                paginate:{
                    offset: 0,
                    limit: 15,
                    current_page: 1,
                    num_pages: 0
                },
                loading:false,
                searched: false
            }
        },
        components:{
            Paginate,
            Loading
        },
        created(){
            this.fetchData();
        },
        mounted(){

            this.chartDiv = document.getElementById("chart");
        },
        computed:{
            sumAmt(){
                return this.cashflowTransactions.reduce(function(a, b){ return a + +b.amount }, 0);
            }
        },
        filters:{
            formatDate(date){
                return moment(date, 'YYYY-MM-DD').format('MMMM YYYY')
            },
            formatDateFull(date){

                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYY')
            },
            formatMoney(n){
                //var n = this,
                var c = isNaN(c = Math.abs(c)) ? 2 : c,
                        d = d == undefined ? "." : d,
                        t = t == undefined ? "," : t,
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
            }
        },
        methods:{

            saveToDashboard(){

                var data = {
                    x_field: 'date_posted',
                    y_field: 'amount',
                    name: this.name + ' Cashflow',
                    chart_type: 'Line',
                    num_results: 12,
                    base_function: this.sourceFn,
                    reportString: this.$route.fullPath,
                    search: {
                        id: this.source_id
                    }
                };

                this.$send(this, 'userChartCreate',data).then(r => {
                    this.accountCashflow = r.accountCashflow;
                    this.paginate.num_pages = Math.ceil(this.accountCashflow.count / this.paginate.limit);
                    if(!this.chart){
                        this.loadChart();
                    }
                });
            },
            paginateClick(pageNum){
                this.paginate.current_page = pageNum;
                this.fetchData();
            },

            fetchData(){
                this.loading = true;
                var data = this.paginate;
                data.id = this.source_id;
                data.offset = this.paginate.limit * (this.paginate.current_page - 1);



                this.$send(this, this.sourceFn,data).then(r => {
                    this.cashflow = r[this.sourceFn];
                    this.cashflowTransactions = r[this.sourceFn + 'Transactions'] || [];
                    this.value = r.lifetimeValue || 0;
                    this.count = r.count;
                    this.paginate.num_pages = Math.ceil(this.count / this.paginate.limit);
                    if(!this.chart && this.cashflow.length){
                        this.loadChart();
                    }
                    this.loading = false;
                    this.searched = true;
                });

            },
            loadChart(){

                var labels = [];
                var data = [];

                this.cashflow.map(function(month){
                    labels.push(moment(month.date_posted, 'YYYY-MM-DD').format('MM/YY'));
                    data.push(month.amount);

                });


                this.chart = new Chart(this.chartDiv, {
                    type: 'line',
                    data:{
                        labels: labels,
                        datasets: [{
                            data: data,
                            borderColor: 'rgba(94, 156, 211, 1)',
                            backgroundColor: 'rgba(94, 156, 211, .25)',
                            hoverBackgroundColor:  'rgba(94, 156, 211, 1)',
                            borderCapStyle: 'butt',
                            borderWidth: 1,
                            fill: false
                        }]
                    },
                    options:{
                        legend: {
                            display: false
                        },
                        tooltips:{
                            backgroundColor: 'rgba(245,247,248,1)',
                            bodyFontColor: '#586266',
                            titleFontColor: '#586266',
                            displayColors:false,

                            callbacks:{
                                label: function(tooltipItem, data){
                                    return "$" + tooltipItem.yLabel.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                                }


                            }
                        }
                    }

                });


            }
        },
        props:['source_id', 'sourceFn', 'label', 'name']
    }
</script>

<style>

    .pagination{
        float: right;
    }
    body .container .row .ledger-col{
        height: 576px;
        border-left: 1px solid #e2e2e2;
        border-right: 1px solid #e2e2e2;
        border-top: 1px solid #e2e2e2;
        padding-top: 0;
    }

    body .container .row .col.chart-col {
        padding-top: 0;
        padding-bottom: 0;
    }


    .ledger-col .head{
        background: #f7f7f7;
    }
    .displayNum{
        font-size: 36px;
        margin: 53px auto;
        display: block;
        font-weight: 600;
    }
    .row > .col.dashboard-section{
        background-color: #f7f7f7;
        padding: 20px;
        margin: 0px 15px 10px 0;
        border: 1px solid #e2e2e2;


    }

    #chart{
        margin-top: 10px;
    }
    .ledger-col  ul.pagination {
        margin-bottom: 0;
    }
    .ledger-col .pagination-description{
        display: inline-block;
        vertical-align: middle;
        padding: 5px 10px;
    }
    /*.ledger-col li.page-item.active, */
    .ledger-col li.page-item.disabled:not(:first-child):not(:last-child) {
        display: none;
    }

    .loader-holder{
        z-index:1000;
        position: absolute;
        top:0;
        left:0;
        bottom:0;
        right:0;
        width:100%;
        height:100%;
        text-align: center;
        background: rgba(255,255,255,.87);
        box-sizing: border-box;
        padding-top:150px;
    }

</style>



// WEBPACK FOOTER //
// Cashflow.vue?152df678